import React from 'react'
import { Link } from 'react-router-dom'

const Header = ({ handleToggle }) => {
    return (
        <>
            <header>
                <div className="topbar d-flex align-items-center">
                    <nav className="navbar navbar-expand gap-3">
                        <div className="mobile-toggle-menu" onClick={handleToggle}><i className="bx bx-menu" /></div>
                        <h2 className="das_heading">Dashboard</h2>
                        <div className="top-menu ms-auto">
                            <ul className="navbar-nav align-items-center gap-1">
                                <li className="nav-item dropdown dropdown-large">
                                    <Link className="nav-link dropdown-toggle dropdown-toggle-nocaret position-relative" to="#" data-bs-toggle="dropdown"><span className="alert-count">6</span>
                                        <i className="bx bx-bell" />
                                    </Link>
                                    <div className="dropdown-menu dropdown-menu-end">
                                        <Link to="">
                                            <div className="msg-header">
                                                <p className="msg-header-title">Notifications</p>
                                                <p className="msg-header-badge">6 New</p>
                                            </div>
                                        </Link>
                                        <div className="header-notifications-list">
                                            <Link className="dropdown-item" to="">
                                                <div className="d-flex align-items-center">
                                                    <div className="notify bg-light-success text-success">
                                                        <i className="bx bx-check-circle" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h6 className="msg-name">
                                                            Game Completed
                                                            <span className="msg-time float-end">2 min ago</span>
                                                        </h6>
                                                        <p className="msg-info">Match #GM248 has been successfully completed.
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link className="dropdown-item" to="">
                                                <div className="d-flex align-items-center">
                                                    <div className="notify bg-light-primary text-primary">
                                                        <i className="bx bx-user-check" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h6 className="msg-name">
                                                            Referee Assigned
                                                            <span className="msg-time float-end">10 min ago</span>
                                                        </h6>
                                                        <p className="msg-info">Referee John Smith assigned to upcoming match.
                                                        </p>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link className="dropdown-item" to="">
                                                <div className="d-flex align-items-center">
                                                    <div className="notify bg-light-info text-info">
                                                        <i className="bx bx-envelope" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h6 className="msg-name">
                                                            Coach Invited
                                                            <span className="msg-time float-end">25 min ago</span>
                                                        </h6>
                                                        <p className="msg-info">Invitation sent to Coach Emma Williams.</p>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link className="dropdown-item" to="">
                                                <div className="d-flex align-items-center">
                                                    <div className="notify bg-light-warning text-warning">
                                                        <i className="bx bx-wallet" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h6 className="msg-name">
                                                            Pending Payout
                                                            <span className="msg-time float-end">1 hr ago</span>
                                                        </h6>
                                                        <p className="msg-info">Referee payout of $150 is pending approval.</p>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link className="dropdown-item" to="">
                                                <div className="d-flex align-items-center">
                                                    <div className="notify bg-light-danger text-danger">
                                                        <i className="bx bx-calendar-x" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h6 className="msg-name">
                                                            Schedule Updated
                                                            <span className="msg-time float-end">3 hrs ago</span>
                                                        </h6>
                                                        <p className="msg-info">Match #GM252 has been rescheduled.</p>
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link className="dropdown-item" to="">
                                                <div className="d-flex align-items-center">
                                                    <div className="notify bg-light-success text-success">
                                                        <i className="bx bx-user-plus" />
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <h6 className="msg-name">
                                                            New Referee Joined
                                                            <span className="msg-time float-end">1 day ago</span>
                                                        </h6>
                                                        <p className="msg-info">Referee Alex Brown has joined your league.</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div className="user-box dropdown px-3">
                            <Link className="d-flex align-items-center nav-link dropdown-toggle gap-3 dropdown-toggle-nocaret" to="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                <img src="images/avatars/avatar-2.png" className="user-img" alt="user avatar" />
                                <div className="user-info">
                                    <p className="user-name mb-0">Pauline Seitz</p>
                                    <p className="designattion mb-0">Super Admin</p>
                                </div>
                            </Link>
                            <ul className="dropdown-menu dropdown-menu-end">
                                <li><Link className="dropdown-item d-flex align-items-center" to="/setting"><i className="bx bx-user fs-5" /><span>Profile</span></Link>
                                </li>
                                <li><Link className="dropdown-item d-flex align-items-center" to="/setting"><i className="bx bx-cog fs-5" /><span>Settings</span></Link>
                                </li>
                                <li><Link className="dropdown-item d-flex align-items-center" to="/"><i className="bx bx-home-circle fs-5" /><span>Dashboard</span></Link>
                                </li>
                                <li>
                                    <div className="dropdown-divider mb-0" />
                                </li>
                                <li><Link className="dropdown-item d-flex align-items-center" to="" data-bs-toggle="modal" data-bs-target="#logout_modal">
                                    <i className="bx bx-log-out-circle" /><span>Logout</span></Link>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </header>
        </>
    )
}

export default Header